import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import {Router} from "@angular/router"
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { MatDialog} from '@angular/material/dialog';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { HttpClient, HttpRequest, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import {MatDialogRef} from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { UploadFilesService } from '../../servicios/upload-files.service';
import { MatTableDataSource} from '@angular/material/table'
import { MatPaginator} from '@angular/material/paginator'
import { environment } from '../../../environments/environment';
import { DlgBusquedasComponent } from '../../components/dlg-busquedas/dlg-busquedas.component';
import { DlgTrabajandoComponent } from '../../components/dlg-trabajando/dlg-trabajando.component';
import { DlgErrorComponent } from '../../components/dlg-error/dlg-error.component';
import { DlgAvisoComponent } from '../../components/dlg-aviso/dlg-aviso.component';

@Component({
  selector: 'app-dlg-envios',
  templateUrl: './dlg-envios.component.html',
  styleUrls: ['./dlg-envios.component.css']
})
export class DlgEnviosComponent implements OnInit {

  idActual="";
  nombre="";
  titulo="";
  progressInfos: any[] = [];
  message: string[] = [];
  respuestaServidor=[];
  dataSourcePaso2 = new MatTableDataSource();
  selectedFiles?: FileList;
  fileInfos?: Observable<any>;
  lblPasoActual="";
  pasosTotales="";
  pasoActual="-1";
  displayedColumns: string[] = ['acciones','propietario','unidad','mail','msgError'];
  @ViewChild('paginador') paginador: MatPaginator;
  nombreConsorcio="";
  txtConsorcio="";
  idConsorcio="";
  nombreMail="";
  idMail="";
  txtMail="";

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private httpClient: HttpClient,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    public thisDialogRef: MatDialogRef<DlgEnviosComponent>,
    private uploadService: UploadFilesService,
  ) { }

  ngOnInit(): void {
    this.pasosTotales="2";
    this.lblPasoActual="Paso Nº: 1 de "+this.pasosTotales;
  }

  uploadFiles(): void {
    this.message = [];
    this.respuestaServidor=[];
    this.dataSourcePaso2== new MatTableDataSource();
    if (this.selectedFiles) {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        this.upload(i, this.selectedFiles[i]);
      }
    }
  }

  cerrarDialogo(dialogoActual) {
    dialogoActual.close();
  }

  cerrar(cadena) {
    this.thisDialogRef.close({mensaje: cadena});
  }

  buscarConsorcio(){
    let dlgBusquedas = this.dialog.open(DlgBusquedasComponent, {
      width: window.innerWidth.toString()+"px",
      disableClose:true
    });
    dlgBusquedas.componentInstance.lblTitBusqueda="Consorcio:";
    dlgBusquedas.componentInstance.codBusqueda="CONSORCIO";
    dlgBusquedas.componentInstance.txtBusc=this.txtConsorcio;
    dlgBusquedas.afterClosed().subscribe(
      data => {
        if (data.idConsorcio!=null){
          this.idConsorcio=data.idConsorcio;
          this.nombreConsorcio=data.nombre;
        }
      }
    );
  }

  eliminarConsorcio(){
    this.idConsorcio="";
    this.nombreConsorcio="";
  }

  buscarMail(){
    let dlgBusquedas = this.dialog.open(DlgBusquedasComponent, {
      width: window.innerWidth.toString()+"px",
      disableClose:true
    });
    dlgBusquedas.componentInstance.lblTitBusqueda="Mail:";
    dlgBusquedas.componentInstance.codBusqueda="MAIL";
    dlgBusquedas.componentInstance.txtBusc=this.txtMail;
    dlgBusquedas.afterClosed().subscribe(
      data => {
        if (data.idMail!=null){
          this.idMail=data.idMail;
          this.nombreMail=data.nombre;
        }
      }
    );
  }

  eliminarMail(){
    this.idMail="";
    this.nombreMail="";
  }

  //#region paso 1
  selectFiles(event): void {
    this.message = [];
    this.progressInfos = [];
    this.selectedFiles = event.target.files;
  }

  upload(idx: number, file: File): void {
    this.progressInfos[idx] = { value: 0, fileName: file.name };
  
    if (file) {
      this.uploadService.upload(file).subscribe(
        (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progressInfos[idx].value = Math.round(100 * event.loaded / event.total);
          } else if (event instanceof HttpResponse) {
            let retorno=JSON.parse(event.body);
            if (retorno['resultado']['msgError']['valorDevuelto']=="01"){
              const msg = "Error:"+file.name+" "+retorno['resultado']['msgError']['mensaje'];
              this.message.push(msg);
            }else{
              for (var i = 0; i < retorno['resultado']['datos'].length; i++) {
                this.respuestaServidor.push({"resultado":retorno['resultado']['datos'][i]['resultado']
                    ,"propietario":retorno['resultado']['datos'][i]['propietario']
                    ,"unidad":retorno['resultado']['datos'][i]['unidad']
                    ,"mail":retorno['resultado']['datos'][i]['mail']
                    ,"msgError":retorno['resultado']['datos'][i]['msgError']
                    ,"idArchivo":retorno['resultado']['datos'][i]['idArchivo']
                })            
              } 
              this.pasoActual='00';
            }
            this.fileInfos = this.uploadService.getFiles();
          }
        },
        (err: any) => {
          this.progressInfos[idx].value = 0;
          const msg = "Hubo un error al subir el archivo: " + file.name;
          this.message.push(msg);
          this.fileInfos = this.uploadService.getFiles();
        });
    }
  }

  anteriorPaso01(){
    this.pasoActual="-1";
    this.message = [];
    this.progressInfos = [];
  }

  muestraSiguiente01(){
    this.lblPasoActual="Paso Nº: 2 de "+this.pasosTotales;
    this.pasoActual="01";
    this.dataSourcePaso2 = new MatTableDataSource<any>(this.respuestaServidor);
    this.dataSourcePaso2.paginator = this.paginador;
    this.paginador._intl.itemsPerPageLabel = 'Items por hoja';
    this.paginador._intl.nextPageLabel  = 'Proxima hoja';
    this.paginador._intl.previousPageLabel  = 'Hoja anterior';
    this.paginador._intl.lastPageLabel  = 'Última hoja';
    this.paginador._intl.firstPageLabel  = 'Primera hoja';
    this.paginador._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      return 'De '+((page * pageSize) + 1) + ' a ' + ((page * pageSize) + pageSize) + ' de ' + length; 
    }
  }

  verPDF(idArchivo){

  }
  //#endregion

  almacenar(){
    let dlgTrabajando = this.dialog.open(DlgTrabajandoComponent, {
      width: '600px',
      disableClose: true
    });
    dlgTrabajando.componentInstance.titulo = "";
    dlgTrabajando.componentInstance.texto = "Intentando almacenar el envio";

    var formData: any = new FormData();
    formData.append('idConexion', this.storage.get("idConexion"));
    formData.append('idEnvio', this.idActual);
    formData.append('nombre', this.nombre);
    formData.append('idConsorcio', this.idConsorcio);
    formData.append('idMail', this.idMail);
    formData.append('dtCorreos', JSON.stringify(this.respuestaServidor));
    
    this.httpClient.post(environment.servidorHttp + 'Sistema/modificarEnvio', formData,
      {
        headers: {
          "Authorization": "Bearer " + this.storage.get("token") 
        },
      })
      .subscribe(data => {
        this.cerrarDialogo(dlgTrabajando);
        if (data['resultado']['msgError']['valorDevuelto'] == "01") {
          let dlgError = this.dialog.open(DlgErrorComponent, {
            width: '600px',
            disableClose: true
          });
          dlgError.componentInstance.titulo = "Error al almacenar el envio";
          dlgError.componentInstance.texto = data['resultado']['msgError']['mensaje'];
        } else if (data['resultado']['msgError']['valorDevuelto'] == "10") {
          let dlgError = this.dialog.open(DlgErrorComponent, {
            width: '600px',
            disableClose: true
          });
          dlgError.componentInstance.titulo = "Error al almacenar el envio";
          dlgError.componentInstance.texto = data['resultado']['msgError']['mensaje'];
          this.router.navigate(['/']);
        } else {
          let dlgAviso = this.dialog.open(DlgAvisoComponent, {
            width: '600px',
            disableClose: true
          });
          dlgAviso.componentInstance.titulo = "Aviso del sistema";
          dlgAviso.componentInstance.texto = data['resultado']['msgError']['mensaje'];
          this.cerrar('almaceno');
        }
      },
        (error: HttpErrorResponse) => {
          this.cerrarDialogo(dlgTrabajando);
          let dlgError = this.dialog.open(DlgErrorComponent, {
            width: '600px',
            disableClose: true
          });
          if (error.status.toString() == "401") {
            dlgError.componentInstance.titulo = "Error al almacenar el envio";
            dlgError.componentInstance.texto = "Su sesión ha finalizado";
            this.router.navigate(['/']);
          } else {
            dlgError.componentInstance.titulo = "Error al almacenar el envio";
            dlgError.componentInstance.texto = error.message + " (" + error.status + ")";
          }
        }
      );
  }
  
}
